// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"201":"media","594":"about","854":"menu","996":"franchise"}[chunkId] || chunkId) + "." + {"88":"05eb827c","114":"00167541","201":"718a5363","354":"7dfeb88d","394":"45fc4aa5","594":"aeebf871","854":"b43c0d13","892":"583d74ce","996":"acb3e69e"}[chunkId] + ".js";
};